import React from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import { colors } from 'utils/colors'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import AppBar from '@material-ui/core/AppBar'
import { signOut } from 'store/auth'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AppbarLogo from 'assets/white_logo.png'

import { getDefaultTimezone } from 'utils/times'
import { Roles } from 'constants/index'
import { getConsoleHome } from 'routes'

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    backgroundColor: theme.palette.background.default,
    color: colors.dark,
    marginLeft: 0,
    marginRight: 50,
    marginTop: 5,
    marginBottom: 5
  },
  logo: {
    height: 65,
    width: 140,
    cursor: 'pointer'
  }
}))

const DesktopActionBar = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const classes = useStyles()
  const { user } = useSelector((state) => state.auth)

  const { conference } = useSelector((state) => state.conference)

  const defaultTimezone = getDefaultTimezone(conference?.timezone)

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}
      style={{
        background: process.env.REACT_APP_NODE_ENV === 'development' ? '#FF8080' : colors.indigo
      }}>
      <Toolbar className={classes.toolbar} style={{ background: 'transparent' }}>
        <img
          className={classes.logo}
          alt="Remy Sharp"
          src={AppbarLogo}
          onClick={() => history.push(getConsoleHome(user))}
        />
        <Typography
          color="textSecondary"
          variant="h5"
          style={{
            marginRight: 30,
            fontWeight: 'bold',
            margin: 'auto',
            color: colors.white
          }}>
          Admin Panel {conference?.confName ? ` - ${conference?.confName}` : ''}
        </Typography>
        {user ? (
          <Button
            variant="contained"
            size="medium"
            disableElevation
            style={{
              color: 'white',
              fontWeight: 'bold',
              background: 'transparent',
              cursor: 'pointer',
              border: '1px solid white'
            }}
            onClick={async () => {
              await dispatch(signOut())
              localStorage.removeItem('badgeOrientation')
              history.push('/')
            }}>
            Logout
          </Button>
        ) : null}
      </Toolbar>
      {user?.role !== Roles.SUPER_ADMIN ? (
        <Box
          sx={{
            fontSize: '12px',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#FEE01C',
            color: '#000000',
            fontWeight: 'bold',
            padding: '4px'
          }}>
          All times are in {conference?.timezone ?? defaultTimezone} Time Zone.
        </Box>
      ) : null}
    </AppBar>
  )
}

const AdminTopBar = () => {
  return (
    <>
      <DesktopActionBar />
    </>
  )
}

export default AdminTopBar
